<template>
    <div class="no-padding no-margin">
        <Networks v-if="route == `/provider/networks`"></Networks>
        <NetworkBuilder  v-if="route == `/provider/networks/builder`"></NetworkBuilder>
        <Network  v-if="route == `/provider/networks/network`"></Network>
    </div>
</template>
<script>

import NetworkBuilder from './NetworkBuilder.vue'
import Networks from './NetworksTable.vue'
import Network from './SingleNetwork.vue'
export default{
    data(){
        return{
        
        }
    },
    components:{
        Network,
        NetworkBuilder,
        Networks,
    },
    computed:{
        route(){
            return this.$route.path
        },
        routeParams(){
            let parsed =''
            if(this.$route.params.name){
                parsed = this.$route.params.name.replace(/ /g, '%20')
            }
            return parsed
        }
    }
}
</script>